export default __webpack_public_path__ + "static/media/blood-test.c2571f48.svg";